<i18n>
{
  "fr": {
    "new": "Nouveau",
    "inProgress": "En cours",
    "waitingForValidation": "A valider",
    "validated": "Validé",
    "generatedMail": "Courrier généré",
    "closed": "Clôturé",
    "loading": "Chargement..."
  }
}
</i18n>
<template>
  <section class="summary main-box">
    <template v-if="loading">
      <strong>{{$t('loading')}}</strong>
      <b-spinner class="ml-auto"></b-spinner>
    </template>
    <div v-else class="requestInformation">
      

      <div v-if="toDelete()" class="alert alert-danger" role="alert">
        <h4 class="alert-heading">Attention !</h4>
        <p>
          Une demande de suppression a été demandée le {{ control.currentStatus.updatedAt | moment("DD/MM/YYYY \à H:mm") }}.
        </p>
      </div>


      <b-row class="timelineBlock justify" v-if="timeline && ! toDelete()">

        <ol class="timeline collectivity" v-for="(history,key, index) in timeline" :key="key">
          <li :class="{ active: isActive(history), last: isLast(timeline, index) }" class="step">
            <p class="stepMobile">
              <span>{{ $t(key) }}</span>
              <template v-if="history && history.createdAt">
                <span>{{ history.createdAt|moment('DD/MM/YYYY') }}</span>
                <span>{{ history.createdAt|moment('HH:mm') }}</span>
              </template>
              <template v-else>
                <span>{{ 'jj/mm/yyyy' }}</span>
                <span>{{ 'HH:mm' }}</span>
              </template>
            </p>
            <span class="number" :data-toggle="{ popover: history }">
              <svg
                class="icon timeline-request-indicator"
                :class="[isActive(history) ? 'active' :'last']"
              >
                <IconHistory></IconHistory>
              </svg>
            </span>

            <div v-if="history" class="popover-content" hidden="hidden">
              <dl>
                <dt class="block">Par :</dt>
                <dd>
                  {{ history.applicationUser.firstName }} {{ history.applicationUser.lastName }}
                  ({{ history.applicationUser.source }})
                </dd>
                <br>
              </dl>
            </div>
          </li>
        </ol>
      </b-row>
    </div>
  </section>
</template>
<script>
import IconHistory from './icons/IconHistory.vue';
import { mapState } from 'vuex';
export default {
  name: 'WorkflowTimeline',
  components: {
    IconHistory,
  },
  data: () => ({
    loading: true,
  }),
  created() {
    this.fetchTimeline();
  },
  computed: {
    ...mapState({
      control: state => state.refControls.control,
      timeline: state => state.workflow.timeline,
    }),
  },
  methods: {
    fetchTimeline() {
      this.$store.dispatch('fetchTimeline').then(() => (this.loading = false));
    },
    isActive(history) {
      return this.control != null && history.status != null
        ? this.control.currentStatus.status.id == history.status.id
        : false;
    },
    isLast(timeline, index) {
      let last = Object.keys(timeline).length - 1;
      return index == last;
    },
    toDelete() {
      if (this.control && this.control.currentStatus && this.control.currentStatus.status && this.control.currentStatus.status.id) {
        if (this.control.currentStatus.status.id == 'toDelete') {
          return true;
        }
      }

      return false;
    },
  },
};
</script>


